<div class="container">
  <h1 class="error-message">{{ errorMessage }}</h1>
  <app-e-button [textContent]="textConstants.CLOSE_BUTTON" btnClass="cancel-button" mat-dialog-close />
</div>
